/**
 * Centralized Permission Definitions and Role Capability Matrix.
 * Follows Open/Closed Principle so adding new roles or plans only requires updating this file.
 */

export const PERMISSIONS = {
  // Client Management
  CLIENTS_READ: 'clients:read',
  CLIENTS_MANAGE: 'clients:manage',

  // Store Management
  STORES_READ: 'stores:read',
  STORES_MANAGE: 'stores:manage',

  // Device Management
  DEVICES_READ: 'devices:read',
  DEVICES_MANAGE: 'devices:manage',

  // User Management
  USERS_READ: 'users:read',
  USERS_MANAGE: 'users:manage',
  USER_DETAIL_VIEW: 'users:detail_view',

  // System Administration
  GATEWAY_ADMIN: 'system:gateway_admin',
};

/**
 * Default Capability Matrix for Roles.
 * In the future, this can be merged dynamically with custom JWT permission claims.
 */
export const ROLE_CAPABILITIES = {
  GATEWAY_ADMIN: Object.values(PERMISSIONS),

  CLIENT_ADMIN: [
    PERMISSIONS.CLIENTS_READ,
    PERMISSIONS.STORES_READ,
    PERMISSIONS.STORES_MANAGE,
    PERMISSIONS.DEVICES_READ,
    PERMISSIONS.DEVICES_MANAGE,
    PERMISSIONS.USERS_READ,
    PERMISSIONS.USERS_MANAGE,
    PERMISSIONS.USER_DETAIL_VIEW,
  ],

  USER: [
    PERMISSIONS.STORES_READ,
    PERMISSIONS.DEVICES_READ,
    PERMISSIONS.USERS_READ,
  ],
};
